export default __webpack_public_path__ + "static/media/One.9ca4f26f.svg";